import { useEffect, useState } from 'react'

import AsteriskIcon from 'mdi-react/AsteriskIcon'
import CheckBoldIcon from 'mdi-react/CheckBoldIcon'
import { useDispatch } from 'react-redux'

import { updatePrice } from '@/ducks/devicePolicyReducer'

const DevicePolicyPriceInput = ({ id, value, currency }: any) => {
  const dispatch = useDispatch()

  const [newValue, setNewValue] = useState(value)
  const [changed, setChanged] = useState(false)

  const save = () => {
    if (!changed) return
    // @ts-ignore
    dispatch(updatePrice(id, newValue))
  }
  // @ts-ignore
  const changeValue = e => {
    setNewValue(e.target.value)
    setChanged(true)
  }

  useEffect(() => {
    setNewValue(value)
  }, [value])

  const isEditing = value !== newValue
  const Icon = isEditing ? AsteriskIcon : CheckBoldIcon

  return (
    <>
      <span className={isEditing ? 'editing' : 'saved'}>
        <Icon />
      </span>

      <span>{currency} </span>

      <input type="number" value={newValue} onChange={changeValue} onBlur={save} />
    </>
  )
}

export default DevicePolicyPriceInput
